module.exports = __webpack_public_path__ + "media/images/emblems/Develier-coat_of_arms-0b3ecb8d7d4adb08d88517be380fd9d7.svg";